/**
 * Feel Great V2 — Semantic Tokens
 *
 * Source of truth: Figma "Feel Great" file, node 94:3 (Semantic layer).
 * Each semantic token aliases a primitive from tokens.ts, exactly as the Figma
 * variables are bound. Do not hand-pick values — they must equal the primitive
 * the Figma variable points at.
 */
import { color } from './tokens'

export const text = {
    primary: color.gray[900], // #1a202c
    secondary: color.gray[600], // #6b8cae
    tertiary: color.gray[500], // #99bcdf
    brand: color.blue[600], // #003b6f
    disabled: color.gray[400], // #ccdeef
    inverse: color.gray[50], // #f8fafc
    danger: color.red[600], // #e83a5f
    success: color.green[600], // #16a34a
    warning: color.orange[600] // #e86900
} as const

export const surface = {
    page: color.gray[50], // #f8fafc
    default: color.gray[100], // #f4f8fb
    raised: color.gray[200], // #f0f2f5
    brandSubtle: color.blue[50], // #ebf2f9
    dangerSubtle: color.red[50], // #fff5f7
    successSubtle: color.green[50], // #f0fdf4
    warningSubtle: color.orange[50] // #fff8f0
} as const

export const border = {
    subtle: color.gray[200], // #f0f2f5
    default: color.gray[300], // #e2e8f0
    strong: color.gray[500], // #99bcdf
    brand: color.blue[600], // #003b6f
    danger: color.red[600], // #e83a5f
    focus: color.blue[500] // #0a5290
} as const

export const brand = {
    default: color.blue[600], // #003b6f
    hover: color.blue[700], // #002d57
    pressed: color.blue[800], // #001f3f
    disabled: color.blue[200] // #99bee3
} as const

export const status = {
    danger: color.red[600], // #e83a5f
    success: color.green[600], // #16a34a
    warning: color.orange[600], // #e86900
    info: color.cyan[600] // #0284c7
} as const

// Semantic elevation (base #000000). Distinct from tokens.ts `shadow/*`
// (base #0F141A) on the foundation board — this is the semantic set.
export const elevation = {
    xs: '0px 1px 2px 0px #0000000D',
    sm: '0px 2px 4px 0px #00000014',
    md: '0px 4px 8px 0px #00000014, 0px 2px 4px 0px #0000000A',
    lg: '0px 12px 24px 0px #0000001A, 0px 4px 8px 0px #0000000F',
    xl: '0px 24px 48px 0px #0000001F, 0px 8px 16px 0px #00000014'
} as const

export const semantic = { text, surface, border, brand, status, elevation } as const
